/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import {
	PanelBody,
	TabPanel,
} from '@wordpress/components';
import { applyFilters, addFilter } from '@wordpress/hooks';

/**
 * Inner dependencies.
 */
import './tab-content.js';
// import './tab-style.js';
// import './tab-advance.js';
import blockInfo from '../constants';
const { hookPrefix } = blockInfo;

addFilter(
	`gutenify-block-${ hookPrefix }-inspector-controls`,
	`Gutenify/Block/${ hookPrefix }/InspectorControls/BasicControls`,
	( content, props ) => {
		return [
			...content,
			<PanelBody /* translators: block settings */
				title={ __( 'Options' ) }
				key={ `gutenify-block-${ hookPrefix }-inspector-controls-basic-controls` }
			>
				<TabPanel
					className="gutenify-editor-tab-panel"
					activeClass="active-tab"
					tabs={ [
						{
							name: 'content',
							title: __( 'Content' ),
							className: 'gutenify-color-normal-tab',
						},
						{
							name: 'style',
							title: __( 'Style' ),
							className: 'gutenify-color-hover-tab',
						},
						{
							name: 'advance',
							title: __( 'Advance' ),
							className: 'gutenify-color-hover-tab',
						},
					] }
				>
					{ ( tab ) => {
						return (
							<>{ applyFilters( `gutenify-block-${ hookPrefix }-options-tab-${ tab.name }`, [], { ...props }, tab ) }</>
						);
					} }
				</TabPanel>
			</PanelBody>,
		];
	}
);
